import { NegotiatedInstrumentKindsOutput } from "../../models/output-objs/NegotiatedInstrumentKindsOutput";
import { LegalFormsOutput } from "../../models/output-objs/LegalFormsOutput";
import { NationsOutput } from "../../models/output-objs/NationsOutput";
import { NegotiatedActivityKindsOutput } from "../../models/output-objs/NegotiatedActivityKindsOutput";
import { ProvinceOutputList } from "../../models/output-objs/ProvinceOutput";
import { RegionOutputList } from "../../models/output-objs/RegionOutput";
import { RestService } from "../../RestService";
import { ReportingSubjectRolesOutput } from "../../models/output-objs/ReportingSubjectRolesOutput";
import { ReportingSubjectTypesOutput } from "../../models/output-objs/ReportingSubjectTypesOutput";
import { StatesOutput } from "../../models/output-objs/StatesOutput";
import { StorTypesOutput } from "../../models/output-objs/StorTypesOutput";
import { SuspicionTypeOutput } from "../../models/output-objs/SuspicionTypeOutput";
import { TicketStatesOutput } from "../../models/output-objs/TicketStatesOutput";
import { ForeignAuthoritiesOutput } from "../../models/output-objs/foreignAuthoritiesOutput";
import { TimezoneOutputList } from "../../models/output-objs/TimezoneOutput";
import { CurrencyOutput } from "../../models/output-objs/currencyOutput";
import { AxiosInstance } from "axios";
import ServerInstanceSingleton from "../../server-istances/Stor-Server/ServerInstance";
import { InternalSuspectTypeOutput } from "../../models/output-objs/InternalSuspectTypeOutput";
import { MacrocategoriesOutput } from "../../models/output-objs/macrocategoriesOutput";


export class CatalogService extends RestService {
    public apiVersion = 'v1';
    static getChoiceList: any;
    private serverInstance: AxiosInstance;
    constructor(){
        super();
        const server = ServerInstanceSingleton.getInstance();
        this.serverInstance =  server.getAxiosInstance();
    }

    public async getRegions(): Promise<RegionOutputList | undefined> {
        try {
            return await this.serverInstance.get(
                this.CATALOG_SERVICE_BASE_URL + '/regions',
                {headers: this.createHttpGenericOptions()}
            );
        }
        catch(error){
            return undefined;
        }
    }

    public async getTimezone(): Promise<TimezoneOutputList | undefined> {
        try {
            return await this.serverInstance.get(
                this.CATALOG_SERVICE_BASE_URL + '/timezones',
                {headers: this.createHttpGenericOptions()}
            );
        }
        catch(error){
            return undefined;
        }
    }

    public async getProvinces(): Promise<ProvinceOutputList | undefined> {
        try {
            return await this.serverInstance.get(
                this.CATALOG_SERVICE_BASE_URL + '/provinces',
                {headers: this.createHttpGenericOptions()}
            );
        }
        catch(error){
            return undefined;
        }
    }

    public async getLegalForms(): Promise<LegalFormsOutput | undefined> {
        try {
            return await this.serverInstance.get(
                this.CATALOG_SERVICE_BASE_URL + '/legal_forms',
                {headers: this.createHttpGenericOptions()}
            );
        }
        catch(error){
            return undefined;
        }
    }

    public async getNations(): Promise<NationsOutput | undefined | undefined> {
        try {
            return await this.serverInstance.get(
                        this.CATALOG_SERVICE_BASE_URL + '/nations',
                        {headers: this.createHttpGenericOptions()}
                    );
        } catch (error){
            return undefined;
        };
    }

    public async getNegotiatedActivityKinds(): Promise<NegotiatedActivityKindsOutput | undefined> {
        try {
            return await this.serverInstance.get(
                this.CATALOG_SERVICE_BASE_URL + '/negotiated_activity_kinds',
                {headers: this.createHttpGenericOptions()}
            );
        }
        catch(error){
            return undefined;
        }
    }

    public async getNegotiatedInstrumentKinds(): Promise<NegotiatedInstrumentKindsOutput | undefined> {
        try {
            return await this.serverInstance.get(
                this.CATALOG_SERVICE_BASE_URL + '/negotiated_instrument_kinds',
                {headers: this.createHttpGenericOptions()}
            );
        }
        catch(error){
            return undefined;
        }
    }

    public async getReportingSubjectRoles(): Promise<ReportingSubjectRolesOutput | undefined> {
        try {
            return await this.serverInstance.get(
                this.CATALOG_SERVICE_BASE_URL + '/reporting_subject_roles',
                {headers: this.createHttpGenericOptions()}
            );
        }
        catch(error){
            return undefined;
        }
    }

    public async getReportingSubjectTypes(): Promise<ReportingSubjectTypesOutput | undefined> {
        try {
            return await this.serverInstance.get(
                this.CATALOG_SERVICE_BASE_URL + '/reporting_subject_types',
                {headers: this.createHttpGenericOptions()}
            );
        }
        catch(error){
            return undefined;
        }
    }

    public async getCurrency(): Promise<CurrencyOutput | undefined> {
        try {
            return await this.serverInstance.get(
                this.CATALOG_SERVICE_BASE_URL + '/currencies',
                {headers: this.createHttpGenericOptions()}
            );
        }
        catch(error){
            return undefined;
        }
    }

    public async getForeignAuthorities(): Promise<ForeignAuthoritiesOutput | undefined> {
        try {
            return await this.serverInstance.get(
                this.CATALOG_SERVICE_BASE_URL + '/foreign-authorities',
                {headers: this.createHttpGenericOptions()}
            );
        }
        catch(error){
            return undefined;
        }
    }

    public async getInternalSuspect(): Promise<InternalSuspectTypeOutput | undefined> {
        try {
            return await this.serverInstance.get(
                this.CATALOG_SERVICE_BASE_URL + '/suspicion_type_internal',
                {headers: this.createHttpGenericOptions()}
            );
        }
        catch(error){
            return undefined;
        }
    }

    public async getMacroCategories(): Promise<MacrocategoriesOutput | undefined> {
        try {
            return await this.serverInstance.get(
                this.CATALOG_SERVICE_BASE_URL + '/macrocategories',
                {headers: this.createHttpGenericOptions()}
            );
        }
        catch(error){
            return undefined;
        }
    }

    public async getFunzionari(): Promise<any | undefined> {
        try {
            return await this.serverInstance.get(
                this.CATALOG_SERVICE_BASE_URL + '/organigramma',
                {headers: this.createHttpGenericOptions()}
            );
        }
        catch(error){
            return undefined;
        }
    }

    public async getSuspicionType(): Promise<SuspicionTypeOutput | undefined> {
        try {
            return await this.serverInstance.get(
                this.CATALOG_SERVICE_BASE_URL + '/suspicion_type',
                {headers: this.createHttpGenericOptions()}
            );
        }
        catch(error){
            return undefined;
        }
    }
    
    public async getAssignType(): Promise<TicketStatesOutput | undefined> {
        try {
            return await this.serverInstance.get(
                this.CATALOG_SERVICE_BASE_URL + '/assignment-type',
                {headers: this.createHttpGenericOptions()}
            );
        }
        catch(error){
            return undefined;
        }
    }

    public async canDeactive(id: number, tableName:string): Promise<any | undefined> {

        let table = ""
        switch (tableName){
            case "catTipologiaNegoziazione": table = "/negotiated_activity_kinds"; break;
            case "catTipologiaStrumNegoziato": table = "/negotiated_instrument_kinds"; break;
            case "naturaSospetto": table = "/reporting_subject_roles"; break;
            case "foreignAuth": table = "/foreign-authorities"; break;
        }
        try {
            return await this.serverInstance.get(
                this.CATALOG_SERVICE_BASE_URL + table + '/' + id + '/canDeactivate',
                {headers: this.createHttpGenericOptions()}
            );
        }
        catch(error){
            return undefined;
        }
    }

    public async updateCatalog(tableName:string, payload:any): Promise<any | undefined> {

        let table = ""
        switch (tableName){
            case "catTipologiaNegoziazione": table = "/negotiated_activity_kinds"; break;
            case "catTipologiaStrumNegoziato": table = "/negotiated_instrument_kinds"; break;
            case "naturaSospetto": table = "/reporting_subject_roles"; break;
            case "foreignAuth": table = "/foreign-authorities"; break;
        }
        try {
            return await this.serverInstance.post(
                this.CATALOG_SERVICE_BASE_URL + table + '/saveAll',
                payload,
                {headers: this.createHttpGenericOptions()}
            );
        }
        catch(error){
            return undefined;
        }
    }

}